export const TERM_LIST_REQUEST = 'TERM_LIST_REQUEST'
export const TERM_LIST_SUCCESS = 'TERM_LIST_SUCCESS'
export const TERM_LIST_FAIL = 'TERM_LIST_FAIL'
export const TERM_LIST_RESET = 'TERM_LIST_RESET'
